import type { KanbanBoardProps } from './kanban-board.types';
import styles from './kanban-board.module.scss';

export function KanbanBoard({ children, className }: KanbanBoardProps) {
  return <div className={`${styles.board} ${className}`}>{children}</div>;
}
